import { api } from "../config/api";
import type { AccountStatusResponse } from "../types/auth.types";
import { parseJsonFromText } from "../utils/http/readJsonResponse";

const AUTH_API_HEADERS: HeadersInit = {
  "Content-Type": "application/json",
};

export async function getAccountStatus(username: string): Promise<AccountStatusResponse> {
  const response = await fetch(api.GET_ACCOUNT_STATUS, {
    method: "POST",
    headers: AUTH_API_HEADERS,
    body: JSON.stringify({ username: username.toLowerCase() }),
    cache: "no-store",
  });
  const text = await response.text();
  return parseJsonFromText(text, {
    status: response.status,
    statusText: response.statusText,
  }) as AccountStatusResponse;
}
